module.exports = __webpack_public_path__ + "img/labor.d00feed7.svg";